import { useEffect, useState } from 'react';
import { useClaimSetupManager } from '../../../hooks/useContracts';
import useConnect from '../../../hooks/useConnect';
import { ChainId, IClaimExecutor, ProviderProps } from '../../../types';
import { ethers } from "ethers";
import { addressStrWithDot } from '../../../lib';
import useCopyToClipboard from "../../../hooks/useCopyToClipboard";
import { ReactComponent as LinkOutSVG } from "../../../assets/linkout.svg";

interface props {
  children: React.ReactNode,
  isOpen: boolean,
  onClose: Function,
  setting: Function,
  items: IClaimExecutor[],
}
const ExecutorsModal = ({ children, isOpen, onClose, setting, items }: props) => {
  const [value, copy] = useCopyToClipboard();
  const [isOpenTooltip, setIsOpenTooltip] = useState(false);
  const [tooltipId, setTooltipId] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [executors, setExecutors] = useState<string[]>([]);
  const [totalFee, setTotalFee] = useState(0);
  const { connect, active, chainId } = useConnect();
  useEffect(() => {
    if (!isOpenTooltip) return;
    setTimeout(() => setIsOpenTooltip(false), 1000);
  }, [tooltipId, isOpenTooltip])

  useEffect(() => {
    setOpenModal(isOpen)
    setExecutors([]);
    setTotalFee(0);
  }, [isOpen])

  const setExecutor = (executor: string, fee: number) => {
    let array = executors;
    let fees = totalFee;
    let index = array.findIndex(element => element === executor);
    if (index < 0) {
      array.push(executor);
      fees += fee;
    } else {
      array.splice(index, 1);
      fees -= fee;
    }
    setExecutors(array);
    setTotalFee(fees);
  }

  const settingExe = () => {
    if (executors.length < 1) return;
    setting(executors, totalFee);
  }

  const handleOnBackDropClick = (e: any) => {
    if (e.target.id === "modal") onClose && onClose();
  };

  if (!openModal) return (null);
  return (
    <div className='fixed top-0 min-w-full h-screen bg-black bg-opacity-[0.5]' id="modal" onClick={handleOnBackDropClick}>
      <div className='absolute top-[30%] right-[50%] translate-x-[50%] rounded-[14px] bg-[#202231] shadow-dark-1000 shadow-md px-3 py-1  w-full max-w-md m-auto'>
        <div className='p-3'>
          <div className='relative'>
            <p className='relative text-lg text-gray-600 dark:text-gray-100 select-none pb-2'>Executors</p>
            <div className='cursor-pointer text-2xl absolute top-0 right-0 dark:text-gray-100 text-gray-600 transition duration-150' onClick={() => onClose()}>
              &times;
            </div>
          </div>
          <div className='pb-[30px]'>
            <p className='text-[12px]'>Executors are bots that claim the rewards for you. Select from the list of current executors.
              You can select multiple executors to guarantee your rewards get claimed automatically.
              It is up to you to check the status of the bots you select to verify they are still active.</p>
          </div>
          <div className='scrollbox h-40 max-h-40 scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-[#161522] overflow-y-scroll'>
            {items.map((item, index) => {
              return (
                <div key={index} className='relative flex justify-between text-[12px] font-sans border-b border-gray-600  px-4 py-3 hover:border-gray-600 hover:bg-slate-700 bg-[#161622] mb-[2px]'
                // onClick={() => {setting([item.executorAddr], item.fee);onClose();}}
                >

                  {(isOpenTooltip && tooltipId == ("score:" + index)) ? <span className="absolute bottom-[-15px] px-[4px] rounded-md bg-slate-600 right-[20px] text-[12px] z-10">Copied!</span> : null}
                  <input
                    className="relative float-left  mr-[6px] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-neutral-300 outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-primary checked:bg-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-primary dark:checked:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
                    type="checkbox"
                    value=""
                    id="checkboxDefault" onChange={() => setExecutor(item.executorAddr, item.fee)} />
                  <div className='w-[80%] flex' onClick={() => { copy(item.executorAddr); setTooltipId("score:" + index); setIsOpenTooltip(true) }}>{addressStrWithDot(item.executorAddr, 10, 10)}

                    <a href={`https://${chainId === 14 ? "flare" : chainId === 19 ? "songbird" : "coston2"}-explorer.flare.network/address/${item.executorAddr}`} className="my-auto ml-[4px] pr-[40px]" target="_blank" onClick={(e) => { e.stopPropagation(); }}><LinkOutSVG className="w-[14px] h-[14px] my-auto" /></a>
                  </div>
                  <div className='w-[20%] text-left'><span>Fee: <mark className="text-[#E9B83B] bg-transparent">{item.fee.toFixed(1)}FLR</mark></span></div>
                </div>
              )
            })}
          </div>
          <div className='flex justify-end mt-2'>
            <button className="bg-[#DAA520] py-1 px-2 rounded-[12px] w-32" onClick={settingExe}>
              <span>SET</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
export default ExecutorsModal;
